import { createGlobalStyle } from 'styled-components';

export const GlobalStyle =createGlobalStyle`
	body{
		background: #242424;
	}
`;